module.exports = __webpack_public_path__ + "img/list-outline-green.64b12187.svg";